import { Eye, HeartHandshake, Lock, MessageSquareHeart, Scale, Sprout } from "lucide-react";
import { IconCard, PageHero, SectionHead } from "../components/site/Blocks";
import { CtaBand } from "../components/site/Cta";

const VALUES = [
  [HeartHandshake, "Dignity", "We support people in ways that protect their privacy, independence and sense of self."],
  [MessageSquareHeart, "Respect", "We listen carefully, communicate honestly and respect each person's choices."],
  [Sprout, "Individualized support", "No two situations are the same. Support is shaped around the individual."],
  [Eye, "Transparency", "We are clear about what we can offer, what we cannot, and what happens next."],
  [Scale, "Integrity", "We act in the best interests of the people we support and the communities we serve."],
  [Lock, "Privacy", "Personal information is collected only when needed and handled with care."],
];

export default function About() {
  return (
    <>
      <PageHero eyebrow="About Us" title="A community care organization built on friendship and trust." image="/images/companion.jpg" alt="Two women sharing a warm moment indoors" testId="about-hero">
        <p>Friendship Pen Care Services is a community care organization offering in-home care services and a range of housing programs for adults and families.</p>
        <p>We work with adults who want to remain comfortable in their own homes, people seeking stable and independent housing, families coordinating care for loved ones, and the caregivers and community partners who make that support possible.</p>
      </PageHero>
      <section className="container-site py-16 sm:py-24 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <SectionHead eyebrow="What we do" title="Care, housing and support, connected." />
        </div>
        <div className="lg:col-span-7 space-y-5 text-[#4A5568] leading-relaxed">
          <p><strong className="text-[#1C2421]">In-home care.</strong> Our caregivers come to clients' homes to provide non-medical support such as companionship, personal support, meal preparation, mobility assistance and respite for family caregivers.</p>
          <p><strong className="text-[#1C2421]">Independent living.</strong> Housing programs for adults who live independently and are looking for stable, comfortable accommodation.</p>
          <p><strong className="text-[#1C2421]">Assisted living care home (coming soon).</strong> A home-like setting for adults who need more daily support. Families can join the interest list today.</p>
          <p><strong className="text-[#1C2421]">Caregiver recruitment.</strong> Welcoming qualified, compassionate caregivers and personal-support professionals who share our values.</p>
          <p><strong className="text-[#1C2421]">Community partnerships.</strong> Working with case managers, social workers, housing organizations, community agencies and property owners to help people access appropriate care and housing resources.</p>
        </div>
      </section>
      <section className="bg-[#F3EFEA] border-y border-[#E5E0D8]">
        <div className="container-site py-16 sm:py-24">
          <SectionHead eyebrow="Our values" title="The principles behind our work." />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-12">
            {VALUES.map(([i, t, d]) => <IconCard key={t} icon={i} title={t}>{d}</IconCard>)}
          </div>
        </div>
      </section>
      <section className="container-site py-16 sm:py-24 max-w-4xl">
        <SectionHead eyebrow="Where we work" title="Serving the Greater Toronto Area.">
          We serve clients, families, caregivers and partners across the Greater Toronto Area, Ontario.
        </SectionHead>
      </section>
      <CtaBand prefix="about-band" />
    </>
  );
}
